









import { Component, Prop, Vue } from 'vue-property-decorator';
import { IMentoringFooterItem } from './types';

@Component
export default class MentoringFooterItem extends Vue
  implements IMentoringFooterItem {
  @Prop({ type: String, default: 'user' })
  readonly icon!: string;

  get iconClass(): string {
    return `item__icon_${this.icon}`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/teamcard/components/item/MentoringFooterItem.vue